import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b723c9e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hide-options" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-angle-right" })
], -1))
const _hoisted_3 = {
  key: 0,
  class: "text",
  style: {"text-align":"left"}
}
const _hoisted_4 = {
  key: 0,
  class: "show-options"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = { class: "navigation-links" }
const _hoisted_7 = ["onClick"]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["side-menu", { show: _ctx.showSidebar }])
  }, [
    _createElementVNode("div", {
      class: "control",
      onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.showNav && _ctx.showNav(...args))),
      title: "Toggle options menu"
    }, [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        (_ctx.showLink)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Hide Options"))
          : _createCommentVNode("", true)
      ]),
      (!_ctx.showSidebar)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createTextVNode(" Show"),
            _hoisted_5,
            _createTextVNode("Options ")
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_TransitionGroup, { name: "fade" }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuItems, (m) => {
            return _withDirectives((_openBlock(), _createElementBlock("div", {
              key: "m.idx",
              class: _normalizeClass({ active: m.current }),
              onClick: $event => (_ctx.menuClicked(m.idx))
            }, [
              _createElementVNode("span", null, _toDisplayString(m.name), 1)
            ], 10, _hoisted_7)), [
              [_vShow, _ctx.showLink && m.show]
            ])
          }), 128))
        ]),
        _: 1
      })
    ])
  ], 2))
}